module.exports = __webpack_public_path__ + "img/zuijia_50.5df20a5e.png";